import { useSearchParams } from "react-router-dom";

export const useGetCurrentFilterParam = () => {
  const [searchParams] = useSearchParams();
  const attendencesMenuStatus = searchParams.get("attendencesMenu");

  return attendencesMenuStatus || "";
};
